var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../../icon";
import { StyledAnchor } from "./back-navigation.styles";
export function BackNavigation(_a) {
    var { iconName, text, alignByContent, isBackToSection } = _a, htmlAnchorElementProps = __rest(_a, ["iconName", "text", "alignByContent", "isBackToSection"]);
    const isAnchor = typeof text === "undefined";
    return (_jsxs(StyledAnchor, Object.assign({ tabIndex: 0, alignByContent: alignByContent || false, isAnchor: isAnchor, isBackToSection: isBackToSection }, htmlAnchorElementProps, { ref: undefined, as: undefined }, { children: [_jsx(Icon, { width: "1.25rem", symbol: iconName }), text && _jsx("span", { children: text })] })));
}
export function BackToPage(props) {
    return (_jsx(BackNavigation, Object.assign({}, props, { text: props.text || "", iconName: "chevronUp" })));
}
export function BackToSection(props) {
    return (_jsx(BackNavigation, Object.assign({}, props, { text: props.text || "", iconName: "chevronLeft", isBackToSection: true })));
}
export function Anchor(props) {
    return _jsx(BackNavigation, Object.assign({}, props, { iconName: "chevronUp", text: undefined }));
}
